import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderAddToCartModalComponent } from 'render/render-shared/ui/render-product-sizes/render-add-to-cart-modal/render-add-to-cart-modal.component';
import { RenderProductSizesModalComponent } from 'render/render-shared/ui/render-product-sizes/render-product-sizes-modal/render-product-sizes-modal.component';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';

import {
  AdditionalInfoPipe, ColorSizesPipe, LastUnitsPipe,
  SizeTypePipe, StockValuePipe, ThresholdLabelPipe, ViewSimilarProductsPipe
} from './pipes/product-purchase.pipes';
import { RenderProductPurchaseOptionsComponent } from './render-product-purchase-options.component';


@NgModule({
  declarations: [
    RenderProductPurchaseOptionsComponent,
    RenderProductSizesModalComponent,
    RenderAddToCartModalComponent,
    ThresholdLabelPipe,
    AdditionalInfoPipe,
    ViewSimilarProductsPipe,
    ColorSizesPipe,
    SizeTypePipe,
    StockValuePipe,
    LastUnitsPipe
  ],
  imports: [
    AltTextPipe,
    CommonModule,
    RenderSharedModule,
    LazyLoadModule
  ],
  exports: [
    RenderProductPurchaseOptionsComponent,
    RenderProductSizesModalComponent,
    RenderAddToCartModalComponent
  ]
})
export class RenderProductPurchaseOptionsModule { }
